<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs6 class="px-1">
        <h1 class="headline">
          ประวัติการส่ง Lalamove
        </h1>
      </v-flex>
      <v-flex xs6 class="px-1 text-xs-right">
        <v-btn fab outline small color="primary" :loading="loading" @click="getData">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="orders"
      class="elevation-1"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
      v-bind:pagination.sync="paginate"
    >
      <template v-slot:items="props">
        <td>{{ props.item.created_at | DateFormat('DD MMM YYYY HH:mm a') }}</td>
        <td>{{ props.item.lalamove_order_ref }}</td>
        <td>{{ props.item.ref_order }}</td>
        <td>
          <v-chip small disabled color="blue" class="white--text">{{
            $t(props.item.order_status)
          }}</v-chip>
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            small
            v-if="props.item.driver_details_json"
            @click="viewDetailDriver(props.item.driver_details_json)"
            color="primary"
            outline
          >
            รายละเอียดคนขับ
          </v-btn>

          <v-btn
            v-if="props.item.order_status === 'EXPIRED' || props.item.order_status === 'REJECTED'"
            flat
            small
            color="primary"
            @click="resubmitLalamove(props.item)"
            outline
          >
            เรียกซ้ำ
          </v-btn>
        </td>
        <td>
          <v-btn
            :loading="loading"
            @click="viewDetail(props.item)"
            color="grey"
            outline
            depressed
            small
          >
            ดูรายละเอียด
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="show" max-width="1000">
      <v-card v-if="order && order.lalamove_order_json">
        <div class="text-xs-right">
          <v-btn flat small fab @click="show = false" :loading="loading">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                จาก
              </v-flex>
            </v-layout>
            <div class="pa-2 z-border-red">
              <template
                v-if="order.lalamove_order_json.stops && order.lalamove_order_json.stops.length > 0"
              >
                {{ order.lalamove_order_json.stops[0].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <div class="form-control" v-if="order.lalamove_order_json.requester_contact">
            ติดต่อผู้ส่ง
            <v-layout wrap>
              <v-flex xs6 class="px-1">
                {{ order.lalamove_order_json.requester_contact.name }}
              </v-flex>
              <v-flex xs6 class="px-1">
                {{ order.lalamove_order_json.requester_contact.phone }}
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <div class="mb-3">
            <v-layout>
              <v-flex class="primary--text pt-2">
                ถึง
              </v-flex>
            </v-layout>

            <div class="pa-2 z-border-red">
              <template
                v-if="order.lalamove_order_json.stops && order.lalamove_order_json.stops.length > 1"
              >
                {{ order.lalamove_order_json.stops[1].addresses.th_TH.displayString }}
              </template>
            </div>
          </div>

          <template
            v-if="
              order.lalamove_order_json.deliveries &&
                order.lalamove_order_json.deliveries.length > 0
            "
          >
            <div class="form-control">
              เพิ่มรายละเอียดถึงคนขับ
              <div class="mb-3">
                {{ order.lalamove_order_json.deliveries[0].remarks }}
              </div>
            </div>

            <div class="form-control">
              ติดต่อผู้รับ
              <v-layout wrap>
                <v-flex xs6 class="px-1">
                  {{ order.lalamove_order_json.deliveries[0].toContact.name }}
                </v-flex>
                <v-flex xs6 class="px-1">
                  {{ order.lalamove_order_json.deliveries[0].toContact.phone }}
                </v-flex>
              </v-layout>
            </div>
          </template>
        </v-card-text>
        <template v-if="order.schedule_at">
          <v-divider />
          <v-card-text>
            <div>
              ตั้งเวลาส่ง (Optional)
              <div>
                {{ order.schedule_at | DateFormat('DD MMM YYYY HH:mm a') }}
              </div>
            </div>
          </v-card-text>
        </template>
        <v-divider />
        <v-card-text>
          <div>ค่าจัดส่ง</div>
          <div>
            {{ order.total_fee_currency }} {{ order.total_fee }} บวกค่าส่งเพิ่มเติมจากทางร้าน
            {{ order.total_fee_currency }}
            {{ lalamove_addon_json ? lalamove_addon_json.shop_fee : 0 }} รวมเป็น
            {{ order.total_fee_currency }}
            {{
              parseInt(order.total_fee) +
                parseInt(lalamove_addon_json ? lalamove_addon_json.shop_fee : 0)
            }}
          </div>

          <span v-if="order.lalamove_order_json.specialRequests">
            {{
              order.lalamove_order_json.specialRequests.includes('COD')
                ? ' ( เก็บเงินปลายทาง )'
                : ''
            }}
          </span>
        </v-card-text>
        <!-- <v-divider /> -->
        <v-divider />
        <v-card-text>
          ยกเลิกคำสั่ง
          <div v-if="order.order_status == 'ASSIGNING_DRIVER' || order.order_status == 'ON_GOING'">
            <v-btn color="red" small outline :loading="loading" @click="cancelLalamoveOrder(order)">
              {{ $t('cancel') }}
            </v-btn>
          </div>
          <div class="primary--text" v-else>
            ไม่สามารถยกเลิกได้
          </div>
        </v-card-text>

        <v-card-text>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="show = false" :loading="loading">
              {{ $t('Back') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="driverDetail" persistent v-model="showDriverDetail" max-width="1000">
      <v-card>
        <div class="text-xs-right">
          <v-btn flat small fab @click="showDriverDetail = false" :loading="loading">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="form-control text-xs-center">
            <div>
              <v-avatar :size="80" color="grey lighten-4" style="border: 1px solid #eee">
                <img
                  class="circle"
                  :src="driverDetail.photo || '/static/img/assets/livechat/profile.png'"
                  alt
                />
              </v-avatar>
            </div>
            <small>{{ driverDetail.plateNumber }}</small>
          </div>

          <div class="form-control">
            <p class="primary-color">ข้อมูลคนขับ</p>
            <v-layout wrap>
              <v-flex xs6 class="px-1">
                <div>ชื่อ</div>

                {{ driverDetail.name }}
              </v-flex>
              <v-flex xs6 class="px-1">
                <div>เบอร์โทร</div>

                {{ driverDetail.phone }}
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>

        <v-card-text>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="showDriverDetail = false" :loading="loading">
              {{ $t('Back') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      paginate: { sortBy: 'created_at', descending: true, rowsPerPage: 25 },
      loading: false,
      headers: [
        { value: 'created_at', text: this.$t('Created Time') },
        {
          value: 'lalamove_order_ref',
          text: this.$t('Lalamove Ref')
        },
        {
          value: 'ref_order',
          text: this.$t('Order No.')
        },
        { value: 'order_status', text: this.$t('Status') },
        {
          text: this.$t('Driver'),
          align: 'center',
          sortable: false
        },
        { text: '', sortable: false }
      ],
      orders: [],
      showPreview: false,
      currentPaymentID: null,
      totalOrders: 0,
      loading: true,
      order: null,
      driverDetail: null,
      showDriverDetail: false,
      show: false,
      lalamove_addon_json: null
    }
  },
  async mounted() {
    this.getData()
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async resubmitLalamove(data) {
      this.loading = true
      try {
        let response = await this.post(
          `lalamove/${this.selectedBot.pageid}/${data.ref_order}/place-order`,
          data.lalamove_order_json
        )
        if (response.success && response.result) {
          this.this.getData()
          this.loading = false
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async getData() {
      let { items, total } = await this.getLalamoveList()
      this.orders = items
      this.totalOrders = total
    },
    viewDetail(order) {
      this.order = order
      if (this.order.addon_json) {
        this.lalamove_addon_json = JSON.parse(this.order.addon_json)
      }
      this.show = true
    },

    viewDetailDriver(driverDetail) {
      this.driverDetail = driverDetail
      this.showDriverDetail = true
    },
    async getLalamoveList() {
      this.loading = true
      try {
        const { sortBy, descending, page, rowsPerPage } = this.pagination || this.paginate
        let response = await this.post(`lalamove/${this.selectedBot.pageid}/order-list`, {
          limit: rowsPerPage,
          offset: rowsPerPage ? ((page || 1) - 1) * rowsPerPage : 0,
          descending: descending,
          sortBy: sortBy || null
        })
        this.loading = false
        if (response.success && response.result)
          return {
            items: response.result,
            total: response.result.length
          }
        else
          return {
            items: [],
            total: 0
          }
      } catch (error) {
        console.error(error)
        this.loading = false
        return {
          items: [],
          total: 0
        }
      }
    },
    async cancelLalamoveOrder(order) {
      if (order.order_status == 'ON_GOING') {
        let second = dayjs().diff(dayjs(order.updated_at), 'second', true)
        if (second >= 300) {
          await this.$swal.fire({
            title: this.$t('Error'),
            text: 'ไม่สามารถยกเลิกเนื่องจากเกินจากเวลาที่กำหนด',
            type: 'error'
          })
          return false
        }
      }
      let result = await this.$swal.fire({
        title: this.$t('Do you want to cancel this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let response = await this.delete(
          `lalamove/${this.selectedBot.pageid}/${order.ref_order}/cancel-order`
        )
        if (response.success) {
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
          location.reload()
        }
      }
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getLalamoveList().then(data => {
          this.orders = data.items
          this.totalOrders = data.total
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/LalamoveOrderList.vue